import {environment} from "../../../environments/environment";
import {FormioBase} from "./formiobase";

// File upload schema
export class FileUpload extends FormioBase {

  public inputType = "file";
  public title = "File";
  public icon = "fa fa-file";
  public schema: any = {
    title: "file",
    components: [
      {
        input: true,
        tableView: true,
        label: "My file",
        inputType: "file",
        key: "myfile",
        image: true,
        imageSize: "200",
        placeholder: "",
        multiple: false,
        defaultValue: "",
        protected: false,
        persistent: true,
        validate: {
          required: false,
          custom: "",
        },
        type: "file",
        tags: [],
        storage: "url",
        url: environment.E_REGISTRATIONS_URL + "/backend/files/generic/document/",
        dir: "translation",
        description: "",
        tooltip: "",
        customClass: "ds-fileupload",
      },
    ],
  };
}
